module.exports = __webpack_public_path__ + "static/media/logo.ce24aa1a.svg";